import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    cardMedia: {
        margin: theme.spacing(4),
        width: '30rem',
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 64px)', // Accounting for the margin
    },
    cardContent: {
        flexGrow: 1, // This will push the actions to the bottom
    },
    cardMediaHidden: {
        margin: theme.spacing(4),
        width: '30rem',
        visibility: 'hidden',
        height: 'calc(100% - 64px)', // Same height calculation as cardMedia
    },
    gridRow: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch', // Make items stretch to fill the container height
    },
    gridItem: {
        display: 'flex', // This will make the Card take full height of the grid item
    },
}));
